import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import {
  HomeUpdatedArrowIcon,
  HomeUpdatedNextIcon,
  HomeUpdatedPrevIcon,
  HomeExpertDomainAutomative,
  HomeExpertDomainHealthcare,
  HomeExpertDomainOnDemand,
  HomeExpertDomainEducation,
  HomeExpertDomainMusic,
  HomeExpertDomainFintech,
  HomeExpertDomainLogistics,
  HomeExpertDomainRetail,
  HomeExpertDomainEcommerce,
  HomeExpertDomainRealEstate,
} from "../../../app-constants";
// Import Swiper React components
import "swiper/css";
import { Link } from "gatsby";

import iOne from "../../images/home-update/industries/automotive.webp";
import iTwo from "../../images/home-update/industries/healthcare.webp";
import iThree from "../../images/home-update/industries/ondemand.webp";
import iFour from "../../images/home-update/industries/education.webp";
import iFive from "../../images/home-update/industries/music.webp";
import iSix from "../../images/home-update/industries/fintech.webp";
import iSeven from "../../images/home-update/industries/logistics.webp";
import iTen from "../../images/home-update/industries/retail.webp";
import iEleven from "../../images/home-update/industries/ecommerce.webp";
import iTwelve from "../../images/home-update/industries/realestate.webp";

function Industry(props) {
  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  React.useEffect(() => {
    if (swiper) {
      console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  const allCss = `
    .serv-item .serv-inner::before {
      content: '';
    }
    .home-inds-one .serv-inner::before {
      background-image: url(${iOne});
    }
    .home-inds-two .serv-inner::before {
      background-image: url(${iTwo});
    }
    .home-inds-three .serv-inner::before {
      background-image: url(${iThree});
    }
    .home-inds-four .serv-inner::before {
      background-image: url(${iFour});
    }
    .home-inds-five .serv-inner::before {
      background-image: url(${iFive});
    }
    .home-inds-six .serv-inner::before {
      background-image: url(${iSix});
    }
    .home-inds-seven .serv-inner::before {
      background-image: url(${iSeven});
    }

    .home-inds-ten .serv-inner::before {
      background-image: url(${iTen});
    }
    .home-inds-eleven .serv-inner::before {
      background-image: url(${iEleven});
    }
    .home-inds-twelve .serv-inner::before {
      background-image: url(${iTwelve});
    }
      `;

  return (
    <>
      <style>{allCss}</style>
      <section className="tekrevol__industry p-100">
        <Container>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={7}
              xxl={7}
              className="m-auto text-center"
            >
              <div
                className="example example-bottom"
                data-text="
            "
              >
                <h2>
                  A Glanced At The Industries We’ve{" "}
                  <span>Already Revolutionized</span>
                </h2>
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="mt-auto mb-auto"
            >
              <div className="industry-wrap">
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={25}
                  slidesPerView={3}
                  // onSlideChange={() => console.log('slide change')}
                  // onSwiper={(swiper) => console.log(swiper)}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    575: {
                      slidesPerView: 1.5,
                    },
                    666: {
                      slidesPerView: 1.8,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1199: {
                      slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                  }}
                  navigation={{
                    prevEl: prevRef?.current,
                    nextEl: nextRef?.current,
                  }}
                  onSwiper={setSwiper}
                  onSlideChange={() => console.log("slide change")}
                  className="industry_serv"
                >
                  <SwiperSlide>
                    <div className="serv-item home-inds-six">
                      <div className="serv-inner">
                        <div className="industry_icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="none"
                            viewBox="0 0 25 25"
                          >
                            <path
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M2.9 3.113v19.2h19.2m-14.4-7.2 4.2-4.2 3 3 6.6-6.6m-4.49-.6h5.09v5.091"
                            ></path>
                          </svg>
                        </div>
                        <Link
                          to="#"
                          aria-label="Automotive"
                          className="title_wrap"
                        >
                          <h3 className="title">Financial Services</h3>
                        </Link>
                        <p>
                          Make transaction processing, compliance, and
                          onboarding easier to lower costs and improve
                          regulatory risk.
                        </p>
                        <Link to="#" aria-label="Automotive">
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-two">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          {HomeExpertDomainHealthcare}
                        </div>
                        <Link
                          to="#"
                          aria-label="Healthcare"
                          className="title_wrap"
                        >
                          <h3 className="title">Healthcare</h3>
                        </Link>
                        <p>
                          Make patient admission and discharge, billing, and
                          administration easier to improve patient care and
                          efficiency.
                        </p>
                        <Link to="#" aria-label="Healthcare">
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-ten">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="none"
                            viewBox="0 0 25 25"
                          >
                            <path
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M15.923 9.116v-3a3.6 3.6 0 1 0-7.2 0v3m-3.673 13.8h14.546c1.285 0 2.327-1.023 2.327-2.284l-1.49-12.116c0-1.262-1.043-2.284-2.328-2.284H6.25c-1.285 0-2.327 1.022-2.327 2.284l-1.2 12.116c0 1.261 1.042 2.284 2.327 2.284"
                            ></path>
                          </svg>
                        </div>
                        <Link
                          to="#"
                          aria-label="On-Demand"
                          className="title_wrap"
                        >
                          <h3 className="title">Retail and eCommerce</h3>
                        </Link>
                        <p>
                          Easily manage inventory, order fulfillment, and
                          customers with intelligent automation.
                        </p>
                        <Link to="#" aria-label="On-Demand">
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-seven">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="22"
                            fill="none"
                            viewBox="0 0 20 22"
                          >
                            <path
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9.956 15.096V11.6m0 0-4.2-2.4m4.2 2.4 4.2-2.4m-4.2-7.8 8.314 4.8v9.6l-8.314 4.8-8.314-4.8V6.2z"
                            ></path>
                          </svg>
                        </div>
                        <Link
                          to="#"
                          aria-label="Education"
                          className="title_wrap"
                        >
                          <h3 className="title">Manufacturing</h3>
                        </Link>
                        <p>
                          Improve productivity in production, quality, and
                          supply chain operations
                        </p>
                        <Link to="#" aria-label="Education">
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="serv-item home-inds-eleven">
                      <div className="serv-inner ">
                        <div className="industry_icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            fill="none"
                            viewBox="0 0 25 24"
                          >
                            <path
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="m7.98 11.4 3 3-3 3m-4.2-9.6h18M5.58 21.6a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v14.4a2.4 2.4 0 0 1-2.4 2.4z"
                            ></path>
                          </svg>
                        </div>
                        <Link to="#" aria-label="Music" className="title_wrap">
                          <h3 className="title">Technology and IT</h3>
                        </Link>
                        <p>
                          Automate software development, testing, support, and
                          infrastructure management to speed up delivery and
                          enhance reliability.
                        </p>
                        <Link to="#" aria-label="Music">
                          {HomeUpdatedArrowIcon}
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
                {/* <div ref={prevRef}>Prev</div>
                                      <div ref={nextRef}>Next</div> */}
                <div ref={prevRef} className="custom-button custom-prev-button">
                  {HomeUpdatedPrevIcon}
                </div>
                <div ref={nextRef} className="custom-button custom-next-button">
                  {HomeUpdatedNextIcon}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Industry;
